import { render } from "./SupportingDocuments.vue?vue&type=template&id=2554f0b8&scoped=true"
import script from "./SupportingDocuments.vue?vue&type=script&lang=js"
export * from "./SupportingDocuments.vue?vue&type=script&lang=js"

import "./SupportingDocuments.vue?vue&type=style&index=0&id=2554f0b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2554f0b8"]])

export default __exports__